export default __webpack_public_path__ + "static/media/Dashboard.981d3e49.svg";